import { Box, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const GlyphIcon = ({ name }) => {
  const theme = useTheme();
  
  const glyphColors = {
    'Happy Face': theme.palette.success.main,
    'I Spy': theme.palette.info.main,
    'Hey April': theme.palette.warning.main,
    'Sweet Dreams': theme.palette.error.main,
    'Open Door': theme.palette.primary.main,
    'Big Smile': theme.palette.secondary.main,
    'Two Towers': theme.palette.info.dark
  };
  
  const color = glyphColors[name] || theme.palette.primary.main;
  
  return (
    <Box 
      sx={{ 
        width: 40, 
        height: 40, 
        borderRadius: '50%', 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: alpha(color, 0.2),
        color: color,
        fontWeight: 'bold',
        border: '2px solid',
        borderColor: alpha(color, 0.5)
      }}
    >
      {name.charAt(0)}
    </Box>
  );
};

export default GlyphIcon;